<template>
  <form-group class="keyword-list-input"
              :label="label"
              :errors="internalErrors"
              @focus="focus">
    <multiselect ref="primaryInput"
                 :placeholder="placeholder"
                 :options="knownTags"
                 :value="internalValue"
                 :clear-on-select="true"
                 :hide-selected="false"
                 :multiple="true"
                 :disabled="disabled"
                 :select-label="$t('hints.select')"
                 :deselect-label="$t('hints.deselect')"
                 :selected-label="$t('hints.selected')"
                 :tag-placeholder="$t('hints.tag')"
                 @search-change="onSearchChange"
                 @remove="onRemove"
                 @tag="onAdd"
                 @select="onSelect"
                 :taggable="true"
                 @open="$emit('open')"
                 @close="$emit('close')">
      <span slot="beforeList" v-if="!searchTerm && knownTags.length === 0"
            class="multiselect__no-options">
        {{$t('hints.noOptions')}}
      </span>
    </multiselect>
  </form-group>
</template>

<script>
import without from 'lodash/without';
import FormGroup from '@/components/FormGroup';
import Input from '@/mixins/Input';
import Multiselect from 'vue-multiselect';

export default {
  name: 'keyword-list-input',
  mixins: [Input],
  components: {
    FormGroup,
    Multiselect,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('placeholders.enter');
      },
    },
  },
  data() {
    const knownTags = [...new Set([
      ...(this.value ? this.value.slice(0) : []),
      ...this.options,
    ]),
    ];
    return {
      searchTerm: null,
      internalValue: this.value || [],
      knownTags,
    };
  },
  methods: {
    focus() {
      this.$refs.primaryInput.activate();
    },
    onSearchChange(searchTerm) {
      this.searchTerm = searchTerm;
    },
    onAdd(tag) {
      if (!this.knownTags.includes(tag)) {
        this.knownTags.push(tag);
      }
      this.onSelect(tag);
    },
    onRemove(tag) {
      this.internalValue = without(this.internalValue, tag);
      this.$emit('input', this.internalValue);
      this.$nextTick(() => this.focus());
    },
    onSelect(tag) {
      if (!this.internalValue.includes(tag)) {
        this.internalValue.push(tag);
      }
      this.$emit('input', this.internalValue);
      this.$nextTick(() => this.focus());
    },
  },
  i18n: {
    messages: {
      de: {
        hints: {
          select: 'Auswählen',
          deselect: 'Entfernen',
          selected: 'Ausgewählt',
          tag: 'Hinzufügen',
          noOptions: 'Füge mit Enter eigene Schlüsselwörter hinzu.',
        },
        placeholders: {
          enter: 'Eintrag hinzufügen',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// KeywordListInput.vue?78f1b25b